/* Tap-to-explain spec values (snippets/gl-term.liquid), 29 Sep 2026.
 * A value button opens its one-line explanation; one open at a time; closes on
 * a second tap, a tap anywhere else, or Esc (focus goes back to the button).
 * On a mouse, CSS also shows the line on hover. The line is placed under the
 * value and flipped to right-align if it would run off the screen, so opening
 * one never moves anything else on the page.
 */
(function () {
  'use strict';
  var open = null;

  function place(b) {
    var p = b.nextElementSibling;
    if (!p) return;
    p.style.left = ''; p.style.right = '';
    var r = p.getBoundingClientRect();
    if (r.right > document.documentElement.clientWidth - 8) { p.style.left = 'auto'; p.style.right = '0'; }
  }
  function close(focus) {
    if (!open) return;
    open.setAttribute('aria-expanded', 'false');
    if (focus) open.focus();
    open = null;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.gl-term__b') : null;
    if (!b) { close(false); return; }
    var was = b === open;
    close(false);
    if (!was) { b.setAttribute('aria-expanded', 'true'); open = b; place(b); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) close(true);
  });
  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest ? e.target.closest('.gl-term') : null;
    if (t) place(t.querySelector('.gl-term__b'));
  });
})();
